// extracted by mini-css-extract-plugin
module.exports = {"noGames":"_UWQ2yST","oops":"_IVMQ8Fb","message":"_39O_ElA"};